import axios from 'axios';
import authHeader from './auth.header';

const API_URL = process.env.VUE_APP_API_URL;

class PreferencesService {
	get(id) {
		return axios.get(API_URL + `preferences/${id}`, {headers: authHeader()});
	}

	update(id, data) {
		localStorage.setItem('preferences', JSON.stringify(data));
		return axios.put(API_URL + `preferences/${id}`, data, {headers: authHeader()});
	}
}

export default new PreferencesService();
